import PropTypes from 'prop-types';

function IFVeggiesActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M14.2 25.2675C14.5 26.7471 16.29 26.4975 17.52 26.3875C18.19 26.3275 18.89 26.1975 19.49 25.8675C20.11 25.5275 20.38 25.1675 20.29 24.4775C19.96 21.8875 20.91 21.8075 20.35 20.3875C19.92 19.2975 20.3 17.3575 20.34 17.1075C20.41 16.6575 20.71 14.9175 21.67 14.4875L20.8 14.4475C19.93 14.4075 19.44 13.8675 18.78 13.5275C18.12 13.1875 17.76 14.1375 17.46 14.1675C16.3 14.2875 17.61 19.9275 15.5 19.9275C15.26 19.9275 14.6 16.9675 13.78 16.0375C13.13 15.2875 12.17 15.5375 11.89 15.4775L14.21 25.2675H14.2Z"
                fill="#C5DB66"
                stroke="#2D2D2D"
                strokeWidth="0.5"
            />
            <path
                d="M26.9 11.1266C26.9 10.2266 26.27 8.42659 25.58 7.84659C24.33 6.78659 24.32 5.61659 23.36 4.71659C22.63 4.02659 21.48 4.24659 20.61 3.73659C19.51 3.09659 19.05 2.37659 17.81 2.09659C16.35 1.77659 15.33 2.33659 13.85 2.54659C13.3 2.62659 12.25 2.34659 11.75 2.57659C11.25 2.80659 10.81 3.22659 10.67 3.75659L10.43 3.73659C10.23 3.71659 10.03 3.83659 9.95001 4.02659C9.68001 4.70659 9.05001 5.21659 8.41001 5.59659C7.67001 6.03659 6.85001 6.37659 6.27001 7.00659C5.35001 8.00659 5.24001 8.97659 6.03001 10.0766C6.03001 10.5766 5.28001 10.7866 5.25001 11.1766C5.22001 11.5566 5.46001 11.9066 5.58001 12.2666C5.68001 12.5466 5.66001 12.9066 5.49001 13.1166C5.36001 13.2766 5.33001 13.4966 5.42001 13.6766C5.61001 14.0466 5.95001 14.3966 6.30001 14.4966C6.77001 14.6366 7.32001 14.3866 7.67001 14.7366C8.05001 15.1166 8.10001 15.7166 8.29001 16.2166C8.81001 17.5866 10.67 18.2866 11.94 17.4366C12.23 17.2366 12.58 17.1166 12.94 17.1366C13.14 17.1366 13.31 17.1866 13.45 17.2666C14.13 17.4266 15.31 17.6666 15.75 17.5266C16.38 17.3266 16.35 16.2266 17.59 16.0966C17.91 16.0666 17.99 14.8166 18.69 15.1766C19.39 15.5366 18.84 16.1166 19.78 16.1566L20.71 16.1966C22.01 17.6666 23.32 17.4066 24.25 16.6566C26.23 15.0366 25.06 14.0966 25.43 13.1066C26.33 13.0266 26.93 12.0466 26.92 11.1466L26.9 11.1266Z"
                fill="#547420"
                stroke="#2D2D2D"
                strokeWidth="0.5"
            />
        </svg>
    );
}

export default IFVeggiesActive;

IFVeggiesActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

IFVeggiesActive.defaultProps = {
    className: null,
};
